
<modal
  size="full"
  :title="title"
  :open="open"
  @close="closeModal"
>
  <div v-if="loading" class="loading-container">
    <spinner inline />
  </div>

  <div v-else-if="display === 'search'" class="container">
    <collection-search-add
      ref="collectionSearchAdd"
      @add="handleAdd"
      @upload="handleUpload"
      @certupload="handleCertUpload"
    />
  </div>

  <div v-else-if="display === 'edit'">
    <div v-if="card" class="grid">
      <section>
        <card-collection-fields
          v-model="card"
          :is-public-collection="collection.public"
        />
      </section>

      <section>
        <card-details-fields v-model="card" :disabled="isLadderCard" />

        <card-advanced-fields v-model="card" is-collection />
      </section>
    </div>
  </div>

  <div v-else class="container">
    <collection-card-estimate
      v-model="card"
      :collection-id="collectionId"
      :display="display"
      @changeDisplay="changeDisplay"
      @close="closeModal"
    />
  </div>

  <template #footer>
    <div v-if="display !== 'edit'">
      <portal-target name="collection-edit-card-modal-footer" />
    </div>

    <div v-if="display === 'edit'">
      <btn
        :title="disabled ? 'Fill out required fields first' : ''"
        :disabled="disabled"
        :loading="saving"
        @click="submit"
      >
        {{ buttonText }}
      </btn>
    </div>
  </template>
</modal>
